module.exports = "<div class=\"advanced-browser\">\n  <advanced-filters></advanced-filters>\n\n  <div class=\"serp-modal__bottom\">\n    <show-offers-button ng-click=\"advancedPopup.close()\"></show-offers-button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/advanced-browser.popup.html
// module id = 303
// module chunks = 0